module.exports = __webpack_public_path__ + "img/try_6.00b857bf.png";